<div class="information-detail" fxLayout="row" fxLayoutAlign="space-between stretch">
    <div fxFlex="35%" class="content-document">
        <div class="card-ic">
            <div class="card-header">
                <label class="titulo-contenido-documento">Factura #{{detalleFact.NumeroFactura?
                    detalleFact.NumeroFactura:''}}</label>
            </div>
            <div class="card-body content-img">
                <app-loader-spinner *ngIf="loaderImage"></app-loader-spinner>
                <lib-ngx-image-zoom [thumbImage]=thumbnail [fullImage]=fullImage [magnification]="0.15"
                    [enableScrollZoom]="false" [enableLens]="true" [lensWidth]="600"
                    [lensHeight]="800" (click)="openModalPdf()">
                </lib-ngx-image-zoom>
                <div *ngIf="errorImage" class="contenido-image-error">
                    <img src="./../../assets/illustrations/sin-previsualizacion.svg" alt="">
                    <p><span>Documento sin previsualización</span><br>
                        Por favor, contacta a la mesa de ayuda para habilitar un formato de impresión. 
                    </p>
                </div>
            </div>
            <div class="card-footer">
            </div>
        </div>
        <div class="card-footer">

        </div>
    </div>

    <div fxFlex="65%" class="content-document-detail">
        <div class="content-card-action">
            <label>Documentos asociados</label>
            <div class="content-icon-header">
                <div>
                    <app-icon-action [icon]="faArrowDownToLine" [messageTooltip]="'Descargar'" [isDropdown]="false"
                        [name]="'descarga'" [positionTooltip]="'bottom-right'" *ngIf="isDownload" [isDisabled]="isDownloadDisabled"
                        (clickAction)="clickPress($event)" [loaderIcon]="loaderIcon"></app-icon-action>
                </div>
                <div class="separador-icon-action" *ngIf="separador">
                    <div class="line">
                    </div>
                </div>
                <div>
                    <app-icon-action [icon]="iconList" [messageTooltip]="mensajeTooltipsList" [isDropdown]="true"
                        [opciones]="opcionesList" [name]="'Listado'" [positionTooltip]="'bottom-right'"
                        (clickAction)="clickPressDropdown($event)"></app-icon-action>
                </div>
            </div>
        </div>
        <div class="contend-body-document">
            <div class="card-ic-no-padding content-table-list" *ngIf="!showLoadingTemplate && activeListOption == 1">
                <app-contenido-carucel [listDocAsociados]="listDocAsociados" [detalleFact]="detalleFact"
                    (pdfClick)="openModalPdfCarrucel($event)" >
                </app-contenido-carucel>
            </div>

            <div class="card-ic-no-padding content-table-list" *ngIf="!showLoadingTemplate && activeListOption == 2"
                [ngClass]="{'fondo-impar': isOdd(dataListado.listTable)}">
                <app-table id="tableListadoCheck" [dataShowItem]="dataListado" [dataConfig]="dataConfigListCheck"
                    (selectActionLabelChip)="clickLabelChip($event)"
                    (selectActionCheckHeader)="selectItemAll($event)"
                    (selectActionCheck)="selectItemCheck($event)" >
                </app-table>
            </div>
            <div class="card-ic-no-padding content-table-list" *ngIf="!showLoadingTemplate && activeListOption == 3"
                [ngClass]="{'fondo-impar': isOdd(dataListado.listTable)}">
                <app-tab [activeTab]="tabActive" [tabs]="tabs" [accionIconRight]="[]" [accionIconLeft]="[]"
                    (clickTab)="cnahgeList($event)" [tabTemplates]="{ tab1: tab1Template, tab2: tab2Template }">
                    <ng-template #tab1Template>
                        <div class="contenido-tabla-detalle">
                            <app-table id="tableListadoRecepciones" [dataShowItem]="dataListadoRelacion"
                                [dataConfig]="dataConfigListRecepciones">
                            </app-table>
                            <div class="contenido-texto-tabla">
                                <p class="title" fxFlex="60%">Total recibido:</p>
                                <p class="descripcion" fxFlex="40%">$
                                    {{totalRecibidoRecepciones| formatearNumero}}</p>
                            </div>
                        </div>
                    </ng-template>
                    <ng-template #tab2Template>
                        <div class="contenido-tabla-detalle">
                            <app-carousel [items]="carouselContentDetallado" [displayCount]="1" [showShadow]="false"
                                [noSpace]="true" [controlPaginadorNormal]="true" [contentTable]="true">
                            </app-carousel>
                            <ng-template #itemDetallado1>
                                <div class="contenido-tabla-carousel">
                                    <app-table id="tableListadoAvance" [dataShowItem]="dataListadoAvance"
                                        [dataConfig]="dataConfigListAvance">
                                    </app-table>
                                    <div class="table-value" *ngIf="dataListadoAvance.listTable.length !== 0">
                                        <div class="content-table-value">
                                            <div>
                                                <p class="title" fxFlex="46%">Retenciones:</p>
                                                <p class="descripcion" fxFlex="46%">$   {{tablaDetalleAvances.retnciones | formatearNumero }}</p>
                                            </div>
                                            <div>
                                                <p class="title" fxFlex="46%">Devolucion anticipo:</p>
                                                <p class="descripcion" fxFlex="46%">$ {{tablaDetalleAvances.devolucion | formatearNumero }}</p>
                                            </div>
                                            <div>
                                                <p class="title" fxFlex="46%">Descuentos:</p>
                                                <p class="descripcion" fxFlex="46%">$ {{tablaDetalleAvances.descuento | formatearNumero}}</p>
                                            </div>
                                        </div>
                                        <div class="content-table-total">
                                            <div>
                                                <p class="title" fxFlex="46%"><b>Total:</b></p>
                                                <p class="descripcion" fxFlex="46%"><b>$ {{tablaDetalleAvances.total | formatearNumero}}</b></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                            <ng-template #itemDetallado2>
                                <div class="card-ic no-shadow">
                                    <div class="contenido-tabla-carousel">
                                        <app-table id="tableListadoEstadoAnticipo"
                                            [dataShowItem]="dataListadoEstadoAnticipo"
                                            [dataConfig]="dataConfigListEstadoAnticipo">
                                        </app-table>
                                        <div class="contenido-texto-tabla" *ngIf="dataListadoEstadoAnticipo.listTable.length !== 0">
                                            <p class="title" fxFlex="60%">Total a Pagar Neto:</p>
                                            <p class="descripcion" fxFlex="40%">$
                                                {{totalNetoPagarAnticipo| formatearNumero}}</p>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                            <ng-template #itemDetallado3>
                                <div class="card-ic no-shadow">
                                    <div class="contenido-tabla-carousel">
                                        <app-table id="tableListadoEstadoRetencion"
                                            [dataShowItem]="dataListadoEstadoRetencion"
                                            [dataConfig]="dataConfigListEstadoRetencion">
                                        </app-table>
                                        <div class="contenido-texto-tabla" *ngIf="dataListadoEstadoRetencion.listTable.length !== 0">
                                            <p class="title" fxFlex="60%">Total a Pagar Neto:</p>
                                            <p class="descripcion" fxFlex="40%">$
                                                {{totalNetoPagarRetencion| formatearNumero}}</p>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                    </ng-template>
                </app-tab>
            </div>
        </div>
        <div class="content-value">
            <div class="table-detail-value" [class.mostrar-detalle]="isPopupVisible">
                <div class="contenido-texto" (click)="showDataValue()">
                    <p class="title" fxFlex="70%">Total por aprobar neto:</p>
                    <p class="descripcion" fxFlex="22%">${{detalleFact.MontoAprobar| formatearNumero}}</p>
                    <span fxFlex="4%"> <fa-icon [icon]="faCircleArrowRight"></fa-icon> </span>
                </div>
                <div class="popup-div" *ngIf="isPopupVisible">
                    <div>
                        <p class="title" fxFlex="70%">Subtotal (Total Neto + Total Exento):</p>
                        <p class="descripcion" fxFlex="22%">${{detalleFact.SubTotalNeto| formatearNumero}}</p>
                    </div>
                    <div>
                        <p class="title" fxFlex="70%">Diferencia por tipo de cambio:</p>
                        <p class="descripcion" fxFlex="22%">${{detalleFact.DiferenciaTipoCambio| formatearNumero}}</p>
                    </div>
                    <div class="line">
                        <p class="title" fxFlex="70%">Total notas de corrección:</p>
                        <p class="descripcion" fxFlex="22%">${{detalleFact.TotalNotasCorreccion| formatearNumero}}</p>
                        <span (click)="showDetailNotas()"> <fa-icon [icon]="iconTotalNotas"></fa-icon> </span>
                    </div>
                    <div *ngIf="showDataNotas">
                        <p class="title" fxFlex="70%">Notas de credito:</p>
                        <p class="descripcion" fxFlex="22%">${{detalleFact.NotaCredito| formatearNumero}}</p>
                    </div>
                    <div *ngIf="showDataNotas">
                        <p class="title" fxFlex="70%">Notas de debito:</p>
                        <p class="descripcion" fxFlex="22%">${{detalleFact.NotaDebito| formatearNumero}}</p>
                    </div>
                    <div class="line">
                        <p class="title" fxFlex="70%">Total Pendiente solicitudes de  notas de corrección:</p>
                        <p class="descripcion" fxFlex="22%">$ {{detalleFact.TotalSolicitudesNotasCorreccion| formatearNumero}}</p>
                        <span (click)="showDetailSolicitudes()"> <fa-icon [icon]="iconTotalPendiente"></fa-icon> </span>
                    </div>
                    <div *ngIf="showDataPendientes">
                        <p class="title" fxFlex="70%">Pendiente de solicitud notas de credito:</p>
                        <p class="descripcion" fxFlex="22%">${{detalleFact.MontoSolicitudesNCPendiente| formatearNumero}}</p>
                    </div>
                    <div *ngIf="showDataPendientes">
                        <p class="title" fxFlex="70%">Pendiente de solicitud notas de debito:</p>
                        <p class="descripcion" fxFlex="22%">${{detalleFact.MontoSolicitudesNDPendiente| formatearNumero}}</p>
                    </div>
                    <div>
                        <p class="title" fxFlex="70%">Ajustes de costo:</p>
                        <p class="descripcion" fxFlex="22%">${{detalleFact.MontoAjustes| formatearNumero}}</p>
                    </div>
                    <div>
                        <p class="title" fxFlex="70%">Anticipo:</p>
                        <p class="descripcion" fxFlex="22%">${{detalleFact.MontoAnticipo| formatearNumero}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-modal [isModalOpen]="modalPdf" [modalTemplate]="modalTemplatePdf" [title]="'Editar Flujo de Aprobación'"
    [nameButtonPrincipal]="'Guardar'" (clikCloseModal)="clikCloseModal($event)" (clikIconModal)="downloadPDF()"
    [isPDF]="true" [separador]="true" (clikZoomInModal)="zoomIn()" (clikZoomOutModal)="zoomOut()">
    <ng-template #modalTemplatePdf>
        <div class="contenido-modal-pdf" >
            <pdf-viewer [style.transform]="'scale(' + zoomLevel + ') translateY(' + offsetY + 'px)'"
            
            [src]="pdfSourceView" [render-text]="true" [original-size]="false"
                style="width: 36%; height: 100vh; transform-origin: top center;">
            </pdf-viewer>
        </div>
    </ng-template>
</app-modal>

<app-snack-bar class="positionSnackbar" [showSnackBar]="showSnackBar" [type]="typeSnackBar"
      [tituloSnackBar]="tituloSnackBar" [mensajeSnackBar]="mensajeSnackBar"
      (closeSnackBar)="closeSnackBar($event)">
</app-snack-bar>